import { UserStore } from '../../user.store';
import { UserService } from '../../../services/user/user.service';
/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NB_AUTH_OPTIONS, NbAuthService, NbAuthResult } from '@nebular/auth';
import { getDeepFromObject } from '../../helpers';
import { AppAlertService } from 'src/app/services/app-alert/app-alert.service';

@Component({
  selector: 'ngx-reset-password-page',
  styleUrls: ['./reset-password.component.scss'],
  templateUrl: './reset-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxResetPasswordComponent implements OnInit {
  minLength: number = this.getConfigValue('forms.validation.password.minLength');
  maxLength: number = this.getConfigValue('forms.validation.password.maxLength');
  redirectDelay: number = this.getConfigValue('forms.resetPassword.redirectDelay');
  showMessages: any = this.getConfigValue('forms.resetPassword.showMessages');
  strategy: string = this.getConfigValue('forms.resetPassword.strategy');
  isPasswordRequired: boolean = this.getConfigValue('forms.validation.password.required');

  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  resetPasswordForm: FormGroup;
  resetCode: string;

  constructor(protected service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef,
    protected fb: FormBuilder,
    protected router: Router,
    private userService: UserService,
    protected route: ActivatedRoute,
    private alertService: AppAlertService,
    private userStore: UserStore) { }

  async ngOnInit() {

    this.resetCode = this.route.snapshot.queryParamMap.get("code");
    console.log(this.resetCode)
    if (!this.resetCode) {
      this.alertService.showErrorAlert("No reset code detected...redirecting");
      setTimeout(()=>{
        this.router.navigate(['/auth/request-password']);
      },
      2000)
    }

    const passwordValidators = [
      Validators.minLength(this.minLength),
      Validators.maxLength(this.maxLength),
    ];
    this.isPasswordRequired && passwordValidators.push(Validators.required);

    this.resetPasswordForm = this.fb.group({
      password: this.fb.control('', [...passwordValidators]),
      confirmPassword: this.fb.control('', [...passwordValidators]),
    });
  }

  get password() { return this.resetPasswordForm.get('password'); }
  get confirmPassword() { return this.resetPasswordForm.get('confirmPassword'); }

  async resetPass() {
    this.errors = this.messages = [];
    this.submitted = true;

    let userReq = {
      password: this.resetPasswordForm.value.password,
      code: this.resetCode,
      passwordConfirmation: this.resetPasswordForm.value.confirmPassword
    }

    console.log(userReq)

    this.userService.resetPassword(userReq).then(res => {
      this.submitted = false;
      if (res.jwt) {
        this.messages = ["Reset successful, please login."];
        // let user = this.userStore.getUser()
        // user.password_expired = false;
        // this.userService.update(user)
      } else {
        this.errors = ["Password reset failed"];
      }

      const redirect = this.route.snapshot.queryParamMap.get("redirect")
      if (redirect) {
        setTimeout(() => {
          return this.router.navigateByUrl(redirect);
        }, this.redirectDelay);
      }else {
        setTimeout(() => {
          return this.router.navigateByUrl("auth/login");
        }, 2000);
      }
      this.cd.detectChanges();
    }).catch(err=>{
      this.submitted = false;
      this.errors = ["Password reset failed."];
      // console.log(this.showMessages?.error, this.errors?.length, !this.submitted)
      // console.log(this.showMessages?.error && this.errors?.length && !this.submitted)
      this.cd.detectChanges();
    })
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }
}
